/* eslint-disable no-console */
import axios from 'axios';

export function ajaxGet(url, successCb = () => {}, errorCb = (error) => { console.error(error); }, params = null) {
  const csrfToken = document.querySelector('meta[name=csrf-token]') ? document.querySelector('meta[name=csrf-token]').content : null;

  const options = {
    headers: {
      'X-CSRF-Token': csrfToken,
      'X-Requested-With': 'XMLHttpRequest',
      Accept: 'application/javascript',
    },
  };

  axios.get(url, { params, ...options })
    .then((response) => {
      successCb(response);
    })
    .catch((error) => {
      errorCb(error);
    });
}

export function ajaxPost(url, successCb = () => {}, errorCb = (error) => { console.error(error); }, params = null) {
  const csrfToken = document.querySelector('meta[name=csrf-token]') ? document.querySelector('meta[name=csrf-token]').content : null;

  const options = {
    headers: {
      'X-CSRF-Token': csrfToken,
      'X-Requested-With': 'XMLHttpRequest',
    },
  };

  axios.post(url, { params, ...options })
    .then((response) => {
      successCb(response);
    })
    .catch((error) => {
      errorCb(error);
    });
}

export function getAjaxModal(modalPath, successCb, errorCb, params = null) {
  const success = successCb || (() => {});
  const defaultErrorCb = (error) => { console.error(error); };

  ajaxGet(
    modalPath,
    (response) => {
      eval(response.data); // eslint-disable-line  no-eval

      success();
    },
    errorCb || defaultErrorCb,
    params,
  );
}

export function insertAjaxContent(url, destElem, destPos = 'beforeend', successCb = () => {}, errorCb = (error) => { console.error(error); }, params = null) {
  const csrfToken = document.querySelector('meta[name=csrf-token]') ? document.querySelector('meta[name=csrf-token]').content : null;

  const options = {
    headers: {
      'X-CSRF-Token': csrfToken,
      'X-Requested-With': 'XMLHttpRequest',
    },
  };

  axios.get(url, { params, ...options })
    .then((response) => {
      destElem.insertAdjacentHTML(destPos, response.data);
    })
    .then((response) => {
      successCb(response);
    })
    .catch((error) => {
      errorCb(error);
    });
}
/* eslint-enable no-console */
